module.exports = __webpack_public_path__ + "media/villous adenoma.6a10cc34.wav";